<script>
export default {
  name: 'SummaryCards',
  props: {
    contasPagar: {
      type: Array,
      required: true,
      default: () => []
    },
    currentUser: {
      type: Object,
      required: true
    }
  },
  computed: {
    valorAberto() {
      return this.contasPagar
        .filter(conta => conta.status === 0)
        .reduce((total, conta) => {
          const valor = parseFloat(conta.valor_pagar || conta.valor || 0)
          return total + (isNaN(valor) ? 0 : valor)
        }, 0)
    },
    valorRealizado() {
      return this.contasPagar
        .filter(conta => conta.status === 1)
        .reduce((total, conta) => {
          const valor = parseFloat(conta.valor_pagar || conta.valor || 0)
          return total + (isNaN(valor) ? 0 : valor)
        }, 0)
    },
    valorTotal() {
      return this.valorAberto + this.valorRealizado
    },
    isAdmin() {
      return this.currentUser?.roles?.some(role => 
        role.name === 'admin' || role.name === 'super'
      ) || false
    }
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined || isNaN(value)) return 'R$ 0,00'
      return Number(value).toLocaleString('pt-BR', { 
        style: 'currency', 
        currency: 'BRL' 
      })
    }
  }
}
</script>

<template>
  <!-- Cards apenas para perfil Admin ou Super Administrador -->
  <div class="row" v-if="isAdmin">
    <!-- Card Valor em Aberto -->
    <div class="col-md-4 mb-3">
      <div class="card">
        <div class="card-body">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Valor em Aberto</p>
              <h4 class="mb-0 text-danger">{{ formatCurrency(valorAberto) }}</h4>
            </div>
            <div class="text-danger">
              <i class="ri-alert-line font-size-24"></i>
            </div>
          </div>
        </div>
        <div class="card-body border-top py-3">
          <div class="text-truncate">
            <span class="text-muted">Contas pendentes</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Realizado -->
    <div class="col-md-4 mb-3">
      <div class="card">
        <div class="card-body">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Realizado</p>
              <h4 class="mb-0 text-success">{{ formatCurrency(valorRealizado) }}</h4>
            </div>
            <div class="text-success">
              <i class="ri-checkbox-circle-line font-size-24"></i>
            </div>
          </div>
        </div>
        <div class="card-body border-top py-3">
          <div class="text-truncate">
            <span class="text-muted">Contas pagas</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Total -->
    <div class="col-md-4 mb-3">
      <div class="card">
        <div class="card-body">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Aberto & Realizado</p>
              <h4 class="mb-0 text-primary">{{ formatCurrency(valorTotal) }}</h4>
            </div>
            <div class="text-primary">
              <i class="ri-money-dollar-circle-line font-size-24"></i>
            </div>
          </div>
        </div>
        <div class="card-body border-top py-3">
          <div class="text-truncate">
            <span class="text-muted">Total geral</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

